import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import session from './modules/session'

import sessionPersistence from './persistences/session'

Vue.use(Vuex)

export default new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	modules: {
		app,
		session,
	},
	plugins: [sessionPersistence],
})
